import React, { useState, useRef } from 'react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import cn from 'classnames'

import { RemoveIcon } from 'images'
import { useOutsideCheckClick } from 'hooks/UseOnClickOutside'

export default function AssetSelectMenu({
  assets,
  selectedAsset,
  onSelect,
  onRemove,
  label,
  placeholder,
  required = false,
  disabled = false,
}) {
  const { t } = useTranslation()
  const [open, setOpen] = useState(false)
  const menuRef = useRef(null)

  useOutsideCheckClick(menuRef, setOpen, open)

  const handleMenuClick = () => {
    if (!disabled && assets.length > 0) {
      setOpen(!open)
    }
  }

  const hasOptions =
    assets.length > 1 || (assets.length === 1 && selectedAsset?.asset_id !== assets[0].asset_id)

  return (
    <div className="test-campaign-asset-select">
      {label && (
        <div className="test-campaign-asset-select__label">
          <strong>{label}</strong>
          {required && <span className="warning-red">*</span>}
        </div>
      )}
      <div
        onClick={handleMenuClick}
        ref={menuRef}
        className={cn('test-campaign-asset-select__wrapper', { open })}
      >
        <div
          className={cn('test-campaign-asset-select__input', {
            open,
            selected: !!selectedAsset,
            disabled,
            empty: assets.length === 0,
          })}
        >
          <div className="d-flex justify-content-between align-items-center w-100 mr-2">
            <div className="d-flex align-items-center">
              <div className="selected-value" style={{ color: selectedAsset ? '#3b3b3b' : '#999' }}>
                {selectedAsset
                  ? `${selectedAsset.asset_label} (ID: ${selectedAsset.asset_id})`
                  : assets.length === 0
                    ? t('Settings.MetaAccess.TestCampaign.noAssetsAvailable', 'No assets available')
                    : placeholder}
              </div>
            </div>

            {!required && selectedAsset && !disabled && (
              <div
                className="remove"
                onClick={(e) => {
                  e.stopPropagation()
                  onRemove?.()
                }}
              >
                <RemoveIcon width={14} />
              </div>
            )}
          </div>
          {!disabled && assets.length > 0 && (
            <div
              style={{
                transitionDuration: '0.2s',
                marginLeft: hasOptions ? 'unset' : 'auto',
                transform: open ? 'rotate(180deg)' : 'rotate(0)',
              }}
              className={cn('events-insights-page__status_menu_arrow', { open })}
            />
          )}
        </div>

        <div className={cn('test-campaign-asset-select__dropdown', { open })}>
          {!hasOptions && assets.length > 0 && (
            <div className="test-campaign-asset-select__dropdown-row">
              <div style={{ color: '#5C5C5C', width: '100%', textAlign: 'center' }}>
                {t('common.noMoreFields')}
              </div>
            </div>
          )}

          {assets.map((asset) => {
            if (selectedAsset?.asset_id === asset.asset_id) return null
            return (
              <div
                className="test-campaign-asset-select__dropdown-row"
                key={asset.asset_id}
                onClick={(e) => {
                  e.stopPropagation()
                  onSelect(asset)
                  setOpen(false)
                }}
              >
                <div>
                  {asset.asset_label} (ID: {asset.asset_id})
                </div>
              </div>
            )
          })}
        </div>
      </div>
    </div>
  )
}

AssetSelectMenu.propTypes = {
  assets: PropTypes.array.isRequired,
  selectedAsset: PropTypes.object,
  onSelect: PropTypes.func.isRequired,
  onRemove: PropTypes.func,
  label: PropTypes.string,
  placeholder: PropTypes.string,
  required: PropTypes.bool,
  disabled: PropTypes.bool,
}
